module.exports = __webpack_public_path__ + "static/media/loading-circle.bdefeddb.png";